import Loading from './loading';
export * from './page-loading';
export default Loading;
